/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { useEffect, useMemo, useState } from 'react';
import {
  isFeatureEnabled,
  FeatureFlag,
  getExtensionsRegistry,
  JsonObject,
  styled,
  t,
} from '@superset-ui/core';
import rison from 'rison';
import Collapse from 'src/components/Collapse';
import { User } from 'src/types/bootstrapTypes';
import { reject } from 'lodash';
import {
  dangerouslyGetItemDoNotUse,
  dangerouslySetItemDoNotUse,
  getItem,
  LocalStorageKeys,
  setItem,
} from 'src/utils/localStorageHelpers';
import ListViewCard from 'src/components/ListViewCard';
import withToasts from 'src/components/MessageToasts/withToasts';
import {
  CardContainer,
  createErrorHandler,
  getRecentActivityObjs,
  getUserOwnedObjects,
  loadingCardCount,
  mq,
} from 'src/views/CRUD/utils';
import { AntdSwitch } from 'src/components';
import getBootstrapData from 'src/utils/getBootstrapData';
import { TableTab } from 'src/views/CRUD/types';
import SubMenu, { SubMenuProps } from 'src/features/home/SubMenu';
import { userHasPermission } from 'src/dashboard/util/permissionUtils';
import { WelcomePageLastTab } from 'src/features/home/types';
import ActivityTable from 'src/features/home/ActivityTable';
import ChartTable from 'src/features/home/ChartTable';
import SavedQueries from 'src/features/home/SavedQueries';
import DashboardTable from 'src/features/home/DashboardTable';
import Button from 'src/components/Button';
import { CloseOutlined, CommentOutlined } from '@ant-design/icons';
import { Tooltip } from 'src/components/Tooltip';

const FixedRightDiv = styled.div`
  position: fixed;
  inset: auto 0px 0px auto;
  padding: 16px;
  z-index: 999;
  text-align: right;
`;

const IconDiv = styled.div`
  width: 22px;
  height: 18px;
`;

const FlyButton = styled.button`
  background-color: ${({ theme }) => theme.colors.primary.base};
  color: #FFFFFF;
  border-radius: 10px;
  font-size: 14px;
  padding: 12px;
  border: none;
`;

function Chatbox() {
  const [chatOpen, setChatOpen] = useState(false);
  const toggleChatBox = () => setChatOpen(!chatOpen);

  return (
    <>
      <FixedRightDiv>
        {chatOpen && (
          <div style={{
            // padding: '8px',
            background: '#fff',
            borderRadius: '8px',
            marginBottom: '8px',
            boxShadow: `rgba(0, 18, 46, 0.16) 0px 8px 36px 0px`,
          }}>
            <iframe
              title='monitra-ai'
              style={{
                borderRadius: '8px',
                zoom: '0.7',
              }}
              width="400px"
              height="700px"
              src='https://flow.linkra.id/webhook/430b07cc-f81d-40e6-977b-2a5d55ec4c59/chat'
            // src='https://monitra-ai.linkra.id/'
            />
          </div>
        )}
        <Tooltip placement='topLeft' title={chatOpen ? "Close Chat" : "Chat Monitra Assistant"}>
          <FlyButton onClick={toggleChatBox}>
            {!chatOpen &&
              "Assistant "
            }
            {chatOpen ?
              <IconDiv className="fa fa-times" /> :
              <IconDiv className="fa fa-comments" />
            }
          </FlyButton>
        </Tooltip>
      </FixedRightDiv>
    </>
  );
}

export default Chatbox;
